import { queryOptions } from '@tanstack/react-query';
import { api as registrationApi } from '@repo/api-kit/registration';
import { searchOrganization } from '#organizations/queries/search-organization';
import { searchOrganizationSlug } from '#organizations/queries/search-organization-slug';

const { ApiOrganization: ApiOrganizationFromJSON } = registrationApi.organizations.firstparty.v5;

const all = ['organization-core'] as const;

/**
 * Adapts GraphQL organization response for fromJSON parsing.
 * GraphQL returns uppercase enum values (e.g., 'ACTIVATED'), but the API fromJSON
 * expects lowercase values (e.g., 'activated').
 */
function adaptGraphQLForFromJSON(graphqlOrg: {
  status: string;
  suspensionReason?: string | null;
  [key: string]: unknown;
}) {
  return {
    ...graphqlOrg,
    status: graphqlOrg.status.toLowerCase(),
    suspensionReason: graphqlOrg.suspensionReason?.toLowerCase() ?? null,
  };
}

export const organizationCoreQueries = {
  all,
  slug: (organizationId: string) =>
    queryOptions({
      queryKey: [...all, 'slug', organizationId] as const,
      queryFn: async () => {
        if (!organizationId) {
          throw new Error('organizationId is required but was not provided');
        }

        return searchOrganizationSlug(organizationId);
      },
      staleTime: Infinity,
      gcTime: Infinity,
    }),
  detail: (organizationId: string) =>
    queryOptions({
      queryKey: [...all, organizationId] as const,
      queryFn: async () => {
        // Fetch organization data via GraphQL and extract the organization core slice
        const graphqlOrg = await searchOrganization({
          includeFinancialDetail: false,
          organizationId,
        });
        return ApiOrganizationFromJSON.fromJSON(adaptGraphQLForFromJSON(graphqlOrg));
      },
      staleTime: Infinity,
      gcTime: Infinity,
    }),
};
